
import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Section from './components/Section';
import ProjectCard from './components/ProjectCard';
import PublicationList from './components/PublicationList';
import Expertise from './components/Expertise';
import Footer from './components/Footer';
import { portfolioData } from './data/portfolioData';
import { FaAward, FaUsers, FaUniversity, FaLinkedin } from 'react-icons/fa';
import { GrMailOption } from 'react-icons/gr';

function App() {
  return (
    <div className="App">
      <Navigation />

      <Hero />

      <Section id="about" title="About">
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          {portfolioData.about.map((paragraph, index) => (
            <p key={index} style={{ marginBottom: '1.5rem', textAlign: 'left' }}>{paragraph}</p>
          ))}
        </div>
      </Section>

      <Section id="expertise" title="Professional Skillset" className="bg-secondary">
        <Expertise skills={portfolioData.skills} />
      </Section>

      <Section id="experience" title="Work Experience">
        <div style={{ display: 'grid', gap: '2rem', maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
          {portfolioData.experience.map((exp, index) => (
            <div key={index} style={{ borderLeft: '2px solid var(--color-accent)', paddingLeft: '1.5rem' }}>
              <h3 style={{ marginBottom: '0.25rem', fontSize: '1.1rem' }}>{exp.role}</h3>
              <h4 style={{ color: 'var(--color-accent)', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.95rem' }}>{exp.company}</h4>
              <p style={{ fontSize: '0.85rem', marginBottom: '0.5rem', color: 'var(--color-text-secondary)' }}>{exp.period}</p>
              <p style={{ margin: 0, fontSize: '0.95rem', lineHeight: '1.6' }}>{exp.description}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section id="publications" title="Scientific Publications" className="bg-secondary">
        <PublicationList publications={portfolioData.publications} />
      </Section>

      <Section id="education" title="Education">
        <div style={{ display: 'grid', gap: '2rem', maxWidth: '800px', margin: '0 auto', textAlign: 'left' }}>
          {portfolioData.education.map((edu, index) => (
            <div key={index} style={{ borderLeft: '2px solid var(--color-accent)', paddingLeft: '1.5rem' }}>
              <h3 style={{ marginBottom: '0.25rem', fontSize: '1.1rem' }}>{edu.degree}</h3>
              <h4 style={{ color: 'var(--color-accent)', marginBottom: '0.5rem', fontWeight: '500', fontSize: '0.95rem' }}>{edu.institution}</h4>
              <p style={{ fontSize: '0.85rem', marginBottom: '0.5rem', color: 'var(--color-text-secondary)' }}>{edu.year} • {edu.status}</p>
            </div>
          ))}
        </div>
      </Section>


      <Section id="projects" title="Selected Works & Research">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
          {portfolioData.projects.map((project, index) => (
            <ProjectCard key={index} project={project} />
          ))}
        </div>
      </Section>



      <Section id="academic-service" title="Academic Service" className="bg-secondary">
        <div style={{ display: 'grid', gap: '2rem', maxWidth: '800px', margin: '0 auto' }}>
          {portfolioData.academicService.map((service, index) => (
            <div key={index} style={{ borderLeft: '2px solid var(--color-accent)', paddingLeft: '2rem' }}>
              <h3 style={{ marginBottom: '0.2rem' }}>{service.role}</h3>
              <h4 style={{ color: 'var(--color-accent)', marginBottom: '0.5rem', fontWeight: '500' }}>{service.organization}</h4>
              <p style={{ fontSize: '0.9rem', marginBottom: '0.5rem', color: 'var(--color-text-secondary)' }}>{service.period}</p>
              <p style={{ margin: 0 }}>{service.description}</p>
            </div>
          ))}
        </div>
      </Section>

      <Section id="honors" title="Honors & Memberships">
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ marginBottom: '2.5rem' }}>
            <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '1.5rem', fontSize: '1.25rem' }}>
              <FaAward style={{ color: 'var(--color-accent)' }} /> Honors & Awards
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem', justifyContent: 'center' }}>
              {portfolioData.honors.map((honor, index) => (
                <div key={index} style={{ padding: '1rem', borderRadius: '12px', background: '#fff', border: '1px solid var(--color-border)', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                  <div style={{ fontWeight: '600', fontSize: '1rem', marginBottom: '0.3rem' }}>{honor.title}</div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>{honor.awarder} • {honor.year}</div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', marginBottom: '1.5rem', fontSize: '1.25rem' }}>
              <FaUsers style={{ color: 'var(--color-accent)' }} /> Professional Memberships
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem', justifyContent: 'center' }}>
              {portfolioData.memberships.map((membership, index) => (
                <div key={index} style={{ padding: '1rem', borderRadius: '12px', background: '#fff', border: '1px solid var(--color-border)', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                  <div style={{ fontWeight: '600', fontSize: '1rem', marginBottom: '0.3rem' }}>{membership.role}</div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>{membership.organization} • {membership.year}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Section>

      <Section id="contact" title="Get in Touch">
        <div className="contact-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem', alignItems: 'center', maxWidth: '800px', margin: '0 auto' }}>
          {/* Left Column: Photo & Name */}
          <div style={{ textAlign: 'center' }}>
            <img
              src={portfolioData.profilePhoto}
              alt={portfolioData.name}
              style={{
                width: '120px',
                height: '120px',
                borderRadius: '50%',
                objectFit: 'cover',
                marginBottom: '1rem',
                border: '1px solid var(--color-border)'
              }}
            />
            <h3 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.2rem' }}>{portfolioData.name}</h3>
            <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.85rem' }}>{portfolioData.pronunciation}</p>
          </div>

          {/* Right Column: Contact Details */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
              <GrMailOption style={{ color: 'var(--color-accent)' }} />
              <a href={`mailto:${portfolioData.email}`} style={{ fontSize: '1rem', color: 'var(--color-text-primary)', textDecoration: 'none' }}>
                {portfolioData.email}
              </a>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
              <FaLinkedin style={{ color: 'var(--color-accent)' }} />
              <a href={portfolioData.socialLinks.find(s => s.label === 'LinkedIn')?.href} target="_blank" rel="noopener noreferrer" style={{ fontSize: '1rem', color: 'var(--color-text-primary)' }}>
                LinkedIn Profile
              </a>
            </div>

            <div style={{ marginTop: '0.5rem' }}>
              <a href={`mailto:${portfolioData.email}`} className="btn" style={{ padding: '0.6rem 1.5rem', fontSize: '0.9rem' }}>
                Send Message
              </a>
            </div>
          </div>
        </div>
      </Section>

      <Footer />
    </div>
  );
}

export default App;
